import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const pen_16_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M13,8.7102 L15.29,10.9992 L7.79,18.5002 L5.5,18.5002 L5.5,16.2102 L13,8.7102
      Z M17,4.7099 L19.29,6.9909 L17,9.2899 L14.71,6.9999 L17,4.7099 Z"
      />
    </svg>
  );
};
